/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_02_Detail_Tournament_1_HeadingInputs */

const en_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constraint versus coordination`)
};

const es_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restricción frente a coordinación`)
};

const de_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwang versus Koordination`)
};

const zh_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`约束与协调`)
};

const ar_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القيد مقابل التنسيق`)
};

const fr_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrainte versus coordination`)
};

const vi_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ràng buộc đối với phối hợp`)
};

const sw_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kizuizi dhidi ya uratibu`)
};

const th_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อจำกัดกับการประสานงาน`)
};

const bs_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ograničenje naspram koordinacije`)
};

const ja_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`制約か、協調か`)
};

const ko_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제약인가, 협응인가`)
};

const pt_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restrição versus coordenação`)
};

const it_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincolo contro coordinazione`)
};

const sv_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begränsning kontra koordination`)
};

const nl_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beperking tegenover coördinatie`)
};

const da_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrænsning over for koordination`)
};

const nb_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrensning mot koordinasjon`)
};

const fi_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rajoite vai koordinaatio`)
};

const pl_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ograniczenie kontra koordynacja`)
};

const ru_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограничение против координации`)
};

const tr_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kısıtlamaya karşı koordinasyon`)
};

const hi_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाधा बनाम तालमेल`)
};

const id_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batasan versus koordinasi`)
};

const ms_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kekangan berbanding koordinasi`)
};

const cs_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omezení versus koordinace`)
};

const el_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Περιορισμός ή συντονισμός`)
};

const he_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אילוץ מול קואורדינציה`)
};

const af_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beperking versus koördinasie`)
};

const hu_method_content_step_02_detail_tournament_1_heading = /** @type {(inputs: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korlátozás kontra koordináció`)
};

/**
* | output |
* | --- |
* | "Constraint versus coordination" |
*
* @param {Method_Content_Step_02_Detail_Tournament_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_02_detail_tournament_1_heading = /** @type {((inputs?: Method_Content_Step_02_Detail_Tournament_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_02_Detail_Tournament_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "de") return de_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "th") return th_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "it") return it_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "da") return da_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "id") return id_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "el") return el_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "he") return he_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "af") return af_method_content_step_02_detail_tournament_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_02_detail_tournament_1_heading(inputs)
	return en_method_content_step_02_detail_tournament_1_heading(inputs)
});